import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { ShieldLogo } from "./Logo";
import { MessageSquare, LogIn, Sparkles, Star } from "lucide-react";

export const FooterCTA = ({ foundingMember = false }) => {
  const handleTalkToArgus = () => {
    const chatLauncher = document.querySelector('[data-testid="chat-launcher"]');
    if (chatLauncher) chatLauncher.click();
  };

  return (
    <footer data-testid="footer-section" className="relative py-24 md:py-32 border-t border-gold/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <span className="font-inter text-xs font-bold tracking-[0.3em] uppercase text-gold block mb-4">Ready to Transform?</span>
            <h2 className="font-inter text-4xl md:text-5xl font-black text-white mb-4">
              Talk to AI Argus <span className="text-gold">Now.</span>
            </h2>
            <p className="text-base md:text-lg text-slate-400 leading-relaxed mb-8 max-w-lg">
              Discover your restaurant's potential in a 5-minute conversation. AI Argus will analyze your needs and show you exactly what's possible.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button data-testid="footer-chat-button" onClick={handleTalkToArgus}
                className="bg-gold hover:bg-gold/90 text-indigo-700 font-inter font-bold text-base px-8 py-6 rounded-none">
                <MessageSquare className="mr-2 w-5 h-5" />
                Start Conversation
                <Sparkles className="ml-2 w-4 h-4" />
              </Button>
              <Button data-testid="footer-login-button" variant="outline"
                className="border-gold/30 text-gold hover:bg-gold/10 font-inter px-8 py-6 rounded-none"
                onClick={() => window.location.href = "/trial/login"}>
                <LogIn className="mr-2 w-4 h-4" /> Login to Trial
              </Button>
            </div>
          </motion.div>

          <motion.div className="flex flex-col items-center lg:items-end"
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
            <ShieldLogo size="lg" />
            <span className="font-inter text-lg font-bold tracking-[0.3em] uppercase text-gold mt-4">Argus Xenia</span>
            <p className="text-sm text-slate-500 mt-2">The Watchful Guardian of Hospitality</p>

            {/* Founding Trust Signal — shown when founding_member_mode is active */}
            {foundingMember && (
              <motion.div
                data-testid="founding-trust-signal"
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.5 }}
                className="flex items-center gap-2 mt-4 px-3 py-1.5 rounded-full text-xs font-medium"
                style={{
                  background: "linear-gradient(135deg, rgba(212,175,55,0.1), rgba(212,175,55,0.04))",
                  border: "1px solid rgba(212,175,55,0.3)",
                  color: "#D4AF37",
                }}
              >
                <Star className="w-3 h-3 fill-current" />
                Powered by Argus Xenia — Founding Partner
              </motion.div>
            )}

            <div className="flex gap-6 mt-8">
              <span className="text-xs text-slate-600 hover:text-slate-400 cursor-pointer transition-colors">Privacy</span>
              <span className="text-xs text-slate-600 hover:text-slate-400 cursor-pointer transition-colors">Terms</span>
              <span className="text-xs text-slate-600 hover:text-slate-400 cursor-pointer transition-colors">Contact</span>
              <span
                onClick={() => window.location.href = "/admin/login?redirect=/admin/command-center"}
                className="text-xs text-slate-700 hover:text-gold cursor-pointer transition-colors"
                title="Admin"
              >
                ⚙
              </span>
            </div>
            <p className="text-xs text-slate-700 mt-4">&copy; 2026 Argus Xenia. All rights reserved.</p>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};
